export const companies = [
  {
    name: 'Amazon.com',
    color: '#FCD246',
    image:
      'https://res.cloudinary.com/gremlin/image/upload/t_default/v1597330569/Downtime/amazon.png',
    full:
      'https://res.cloudinary.com/gremlin/image/upload/t_default/v1597330569/Downtime/amazon-full.svg',
    revenue: {
      year: 115879000000,
      second: 3671.98,
    },
  },
  {
    name: 'WalMart.com',
    color: '#23C386',
    image:
      'https://res.cloudinary.com/gremlin/image/upload/t_default/v1597330571/Downtime/walmart.png',
    full:
      'https://res.cloudinary.com/gremlin/image/upload/t_default/v1597330571/Downtime/walmart-full.svg',
    revenue: {
      year: 21443900000,
      second: 679.52,
    },
  },
  {
    name: 'HomeDepot.com',
    color: '#009580',
    image:
      'https://res.cloudinary.com/gremlin/image/upload/t_default/v1597330569/Downtime/homedepot.png',
    full:
      'https://res.cloudinary.com/gremlin/image/upload/t_default/v1597330569/Downtime/homedepot-full.svg',
    revenue: {
      year: 7613000000,
      second: 241.24,
    },
  },
  {
    name: 'BestBuy.com',
    color: '#EF789D',
    image:
      'https://res.cloudinary.com/gremlin/image/upload/t_default/v1597330569/Downtime/bestbuy.png',
    full:
      'https://res.cloudinary.com/gremlin/image/upload/t_default/v1597330569/Downtime/bestbuy-full.svg',
    revenue: {
      year: 6126000000,
      second: 194.12,
    },
  },
  {
    name: 'Costco.com',
    color: '#E6325A',
    image:
      'https://res.cloudinary.com/gremlin/image/upload/t_default/v1597330569/Downtime/costco.png',
    full:
      'https://res.cloudinary.com/gremlin/image/upload/t_default/v1597330569/Downtime/costco-full.svg',
    revenue: {
      year: 6108500000,
      second: 193.57,
    },
  },
  {
    name: 'Macys.com',
    color: '#FCD246',
    image:
      'https://res.cloudinary.com/gremlin/image/upload/t_default/v1597330570/Downtime/macys.png',
    revenue: {
      year: 5828800000,
      second: 184.7,
    },
  },
  {
    name: 'Wayfair.com',
    color: '#F57300',
    image:
      'https://res.cloudinary.com/gremlin/image/upload/t_default/v1597330571/Downtime/wayfair.png',
    revenue: {
      year: 5164300000,
      second: 163.65,
    },
  },
  {
    name: 'QVC.com',
    color: '#71B0EB',
    image:
      'https://res.cloudinary.com/gremlin/image/upload/t_default/v1597330570/Downtime/qvc.png',
    revenue: {
      year: 4482000000,
      second: 142.03,
    },
  },
  {
    name: 'Target.com',
    color: '#0F8CCF',
    image:
      'https://res.cloudinary.com/gremlin/image/upload/t_default/v1597330571/Downtime/target.png',
    revenue: {
      year: 4458300000,
      second: 141.28,
    },
  },
  {
    name: 'Nordstrom.com',
    color: '#4F3093',
    image:
      'https://res.cloudinary.com/gremlin/image/upload/t_default/v1597330570/Downtime/nordstrom.png',
    revenue: {
      year: 4344500000,
      second: 137.67,
    },
  },
  {
    name: 'Kohls.com',
    color: '#9769FF',
    image:
      'https://res.cloudinary.com/gremlin/image/upload/t_default/v1597330570/Downtime/kohls.png',
    revenue: {
      year: 3783300000,
      second: 119.89,
    },
  },
  {
    name: 'Gap.com',
    color: '#23C386',
    image:
      'https://res.cloudinary.com/gremlin/image/upload/t_default/v1597330569/Downtime/gap.png',
    revenue: {
      year: 3416300000,
      second: 108.26,
    },
  },
  {
    name: 'Lowes.com',
    color: '#009580',
    image:
      'https://res.cloudinary.com/gremlin/image/upload/t_default/v1597330570/Downtime/lowes.png',
    revenue: {
      year: 3103300000,
      second: 98.34,
    },
  },
  {
    name: 'Nike.com',
    color: '#EF789D',
    image:
      'https://res.cloudinary.com/gremlin/image/upload/t_default/v1597330570/Downtime/nike.png',
    revenue: {
      year: 2990500000,
      second: 94.76,
    },
  },
  {
    name: 'WilliamsSonoma.com',
    color: '#E6325A',
    image:
      'https://res.cloudinary.com/gremlin/image/upload/t_default/v1597330571/Downtime/williamssonoma.png',
    revenue: {
      year: 2900300000,
      second: 91.9,
    },
  },
  {
    name: 'JCPenney.com',
    color: '#FCD246',
    image:
      'https://res.cloudinary.com/gremlin/image/upload/t_default/v1597330570/Downtime/jcpenney.png',
    revenue: {
      year: 2427000000,
      second: 76.91,
    },
  },
  {
    name: 'Staples.com',
    color: '#F57300',
    image:
      'https://res.cloudinary.com/gremlin/image/upload/t_default/v1597330571/Downtime/staples.png',
    revenue: {
      year: 2347100000,
      second: 74.38,
    },
  },
  {
    name: 'SamsClub.com',
    color: '#71B0EB',
    image:
      'https://res.cloudinary.com/gremlin/image/upload/t_default/v1597330570/Downtime/samsclub.png',
    revenue: {
      year: 2270200000,
      second: 71.94,
    },
  },
  {
    name: 'Walgreens.com',
    color: '#0F8CCF',
    image:
      'https://res.cloudinary.com/gremlin/image/upload/t_default/v1597330571/Downtime/walgreens.png',
    revenue: {
      year: 2034700000,
      second: 64.48,
    },
  },
  {
    name: 'Sears.com',
    color: '#4F3093',
    image:
      'https://res.cloudinary.com/gremlin/image/upload/t_default/v1597330571/Downtime/sears.png',
    revenue: {
      year: 1986500000,
      second: 62.95,
    },
  },
  {
    name: 'BedBathAndBeyond.com',
    color: '#9769FF',
    image:
      'https://res.cloudinary.com/gremlin/image/upload/t_default/v1597330569/Downtime/bedbathandbeyond.png',
    revenue: {
      year: 1984600000,
      second: 62.89,
    },
  },
  {
    name: 'HSN.com',
    color: '#23C386',
    image:
      'https://res.cloudinary.com/gremlin/image/upload/t_default/v1597330570/Downtime/hsn.png',
    revenue: {
      year: 1881600000,
      second: 59.62,
    },
  },
  {
    name: 'Groupon.com',
    color: '#009580',
    image:
      'https://res.cloudinary.com/gremlin/image/upload/t_default/v1597330569/Downtime/groupon.png',
    revenue: {
      year: 1839800000,
      second: 58.3,
    },
  },
  {
    name: 'Overstock.com',
    color: '#EF789D',
    image:
      'https://res.cloudinary.com/gremlin/image/upload/t_default/v1597330570/Downtime/overstock.png',
    revenue: {
      year: 1808800000,
      second: 57.32,
    },
  },
  {
    name: 'NeimanMarcus.com',
    color: '#E6325A',
    image:
      'https://res.cloudinary.com/gremlin/image/upload/t_default/v1597330570/Downtime/neimanmarcus.png',
    revenue: {
      year: 1692100000,
      second: 53.62,
    },
  },
]
